import React from 'react';
import config from 'react-global-configuration';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { NodeActivity } from '../../../../types/uncinc_profile/nodes';
import type { SiteDomain } from '../../../../types';
import TeaserBuurtboerderij from './TeaserBuurtboerderij';
import TeaserRegenboog from './TeaserRegenboog';

interface NodeActivityTeaserProps {
  entity: ImmutableEntity<NodeActivity>;
  wide?: boolean;
  flipped?: boolean;
  activeFilters?: Record<string, any>;
}

const NodeActivityTeaser: React.FC<NodeActivityTeaserProps> = (props) => {
  const {
    entity,
    wide,
    flipped,
    activeFilters,
  } = props;

  const currentDomain = config.get('CURRENT_DOMAIN') as SiteDomain;

  switch (currentDomain) {
    case 'buurtboerderij': {
      return <TeaserBuurtboerderij entity={entity} />;
    }

    case 'regenboog':
    default: {
      return (
        <TeaserRegenboog
          entity={entity}
          wide={wide}
          flipped={flipped}
          activeFilters={activeFilters}
        />
      );
    }
  }
};

export default NodeActivityTeaser;
